import React from "react"

import { withHero } from "./withHero"
import { ImageVideo } from "../../ImageVideo/ImageVideo"
import { TextGrid } from "../../TextGrid/TextGrid"
import { PositionWrapper, SectionInner } from "../SectionStyles"

export const Hero = withHero(
  ({ handlePromoClick, title, subtitle, content, link, imageVideo, position, isDomReady }): JSX.Element => (
    <PositionWrapper position={position}>
      {imageVideo ? (
        <SectionInner>
          {isDomReady ? (
            <ImageVideo imageVideo={imageVideo} ratio={"1/1"} />
          ) : (
            <div style={{ backgroundImage: `url(${imageVideo?.desktop?.asset?.url})`, backgroundSize: "cover", width: "100%", height: "100%" }}></div>
          )}
        </SectionInner>
      ) : null}
      <SectionInner center={"true"}>
        <TextGrid title={title} titleSize={"lg"} subtitle={subtitle} content={content} link={link} handlePromoClick={handlePromoClick} />
      </SectionInner>
    </PositionWrapper>
  )
)

export default Hero
